/** Shared formatting helpers for the chat tool-call renderers. */

/** Reads the client tool-call bookkeeping the server merges into tool output. */
export function getToolOutputLastAction(output: unknown): { action?: string; at?: string } {
  if (!output || typeof output !== 'object') return {}
  const mp = (output as Record<string, unknown>)._mp
  if (!mp || typeof mp !== 'object') return {}
  const last = (mp as Record<string, unknown>).lastAction
  if (!last || typeof last !== 'object') return {}
  const { action, at } = last as Record<string, unknown>
  return {
    action: typeof action === 'string' ? action : undefined,
    at: typeof at === 'string' ? at : undefined
  }
}

/** Compact relative timestamp; avoids pulling date-fns into the add-in bundle. */
export function timeAgo(iso?: string): string {
  if (!iso) return ''
  const t = new Date(iso).getTime()
  if (Number.isNaN(t)) return ''
  const seconds = Math.max(0, Math.round((Date.now() - t) / 1000))
  if (seconds < 60) return 'just now'
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes} min ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours} h ago`
  return new Date(iso).toLocaleDateString()
}

export const clip = (value: string, max = 280): string => (value.length > max ? `${value.slice(0, max)}…` : value)

export const formatCount = (value: unknown): string => (typeof value === 'number' ? value.toLocaleString() : '?')
